export enum PostMessageType {
    FILTER_CHANGED = 'FILTER_CHANGED',
    SET_MODAL_TITLE = 'SET_MODAL_TITLE',
}
